module.exports = __webpack_public_path__ + "img/wheel_branco.bbaefacb.png";